import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, Observable, Subject } from 'rxjs'; // Import Observable


@Injectable()
export class GlobleDataShearService {
    roleName ='';
    $sharedData = new Subject()
    datas = new Subject();
      items: any;
      private sharedDataSubject = new BehaviorSubject<any>(null);
      $sharedItemData = this.sharedDataSubject.asObservable();
      constructor(private cookieService: CookieService) {
    
     }
    
    getSelectRoleName(){
        return this.roleName = this.roleName == '' ? this.cookieService.get('_PAORN') : this.roleName;
    }
    
    setSelectRoleName(roleName:string){
        this.roleName = roleName;
    }
    
    setItemData(item){
      console.log(item)
      this.sharedDataSubject.next(item);
      this.items = item;
    }
    
    getItemData(){
      return this.items;
    }
    
}



// WEBPACK FOOTER //
// ./src/app/application/services/data-shearing/globle-data-shear.service.ts